export default function SvgFlagCS(props) {
    return (
        <svg {...props} viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28 0H0V8.5H28V0Z" fill="white"/>
            <path d="M28 8.5H0V17H28V8.5Z" fill="#D7141A"/>
            <path d="M0 17V0L13.0312 8.5L0 17Z" fill="#11457E"/>
        </svg>
    )
}